
<div id="content" class="main-content">
    <div class="notification-shape shape-box " id="notification-corner-expand-shape" data-path-to="m 0,0 500,0 0,500 -500,0 z">
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 500 500" preserveAspectRatio="none">
            <path d="m 0,0 500,0 0,500 0,-500 z"/>
        </svg>
    </div>
    <!-- <div class="alert alert-gradient" role="alert" style="opacity: 0;position: fixed;z-index: 100;right: 15%;"> 
        <i class="flaticon-cancel-12 close ml-3" data-dismiss="alert"></i> <strong>Visite créée</strong> le commercial va être notifié dans quelques instants</div> -->
    <div class="container">
        <div class="col-12 pl-0">
            <div class="crumbs breadcrumbs-style-2">
                <ul class="breadcrumb">
                    <li class="mt-3"><a href="dashboard" routerLink="/dashboard"><i class="flaticon-home-fill"></i></a>
                    </li>
                    <li class="active mt-3 current_arian"><a href="javascript:void(0);" class="current_arian">Utilisateurs de WAM</a></li>
                </ul>
            </div> 
        </div>
        <div *ngIf="!loading_tab_details" class="page-header" [ngStyle]="mobile ? {'display': 'flex','flex-wrap': 'wrap'} : {}">
            <div class="page-title mt-3">
                <h2 style="color:black">Liste des utilisateurs</h2>
            </div>
            <!-- <div class="row d-flex" style="justify-content: flex-end; margin: auto;">
                <a type="button" class="btn btn-gradient-dark ml-2 mb-2 btn-rounded btn_new_customer" href="addProfil" routerLink="/addProfil" >
                  <i class="flaticon-plus-1 mr-2"></i> 
                  Nouveau profil
                </a>
            </div> -->
        </div>
        <div class="row layout-spacing">
            <div class=" layout-spacing" style="width: -webkit-fill-available;">
                <div class="statbox widget box box-shadow">
                    <div class="widget-content widget-content-area border-top-tab"> 
                        <ul class="nav nav-pills justify-content-around mb-3" role="tablist">
                            <li class="nav-item">
                                <a class="bordred-btn nav-link nav-item active btn-rounded" id="rounded-pills-profile-tab2" data-toggle="tab" href="#border-top-users" role="tab" aria-selected="true"><i class="flaticon-location-1"></i> Utilisateurs</a>
                            </li>
                            <li class="nav-item">
                                <a class="bordred-btn nav-link nav-item btn-rounded" id="ronded-pills-contact-tab2" data-toggle="tab" href="#border-top-team" role="tab" aria-selected="false"><i class="flaticon-user-8"></i> Equipe</a>
                            </li>
                            <li class="nav-item">
                                <a class="bordred-btn nav-link nav-item btn-rounded" id="rounded-pills-home-tab2" data-toggle="tab" href="#border-top-profiles" role="tab"  aria-selected="false"><i class="flaticon-bell-27"></i> Profiles</a>
                            </li>
                            <li class="nav-item">
                                <a class="bordred-btn nav-link nav-item btn-rounded" id="rounded-pills-home-tab2" data-toggle="tab" href="#conversation" role="tab"  aria-selected="false"><i class="flaticon-bell-27"></i> Rôles</a>
                            </li>
                        </ul> 
                        <div class="tab-content" id="pills-tabContent">
                            <div class="tab-pane fade  show active" id="border-top-users" role="tabpanel">
                                <app-user-list></app-user-list>                               
                            </div>
                            <div class="tab-pane fade" id="border-top-team" role="tabpanel">
                                <app-equipe></app-equipe>                            
                            </div>
                            <div class="tab-pane fade" id="border-top-profiles" role="tabpanel">
                                <app-profiles></app-profiles>
                            </div>
                            <div class="tab-pane fade" id="conversation" role="tabpanel">
                                <app-roles></app-roles>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>